import { downloadCsv } from '@quickbit/backoffice-core-frontend';
import { getOrders, MerchantOrderFilters } from '../api';

export const createReport = async ({
  filters,
  includeIncomplete,
}: {
  includeIncomplete: boolean;
  filters: MerchantOrderFilters;
}) => {
  const reportOrderData = await getOrders({
    filters,
  });
  const reportOrders = reportOrderData.orders.map(
    ({ uuid, referenceId, completedAt, settlement, createdAt }) => ({
      date: includeIncomplete
        ? createdAt.toLocaleString()
        : completedAt?.toLocaleString(),
      orderId: uuid,
      referenceId: referenceId,
      amount: settlement?.euroAmount,
      fee: settlement?.euroFee,
    })
  );
  if (reportOrders.length < 1) return;

  const dataArray = [
    'Overview',
    'Currency: Euro',
    'Aggregated order value,Aggregated fee value',
    `${reportOrderData.aggregatedData.settlementAmount.toString()},${reportOrderData.aggregatedData.processingFee.toString()}`,
    '',
    'Orders',
  ];
  dataArray.push(
    [
      includeIncomplete ? 'Created' : 'Completed',
      'Order ID',
      'Reference ID',
      'Amount',
      'Fee',
    ].join(',')
  );
  const reportArray = [
    ...dataArray,
    ...reportOrders.map((row) =>
      Object.values(row)
        .map((value) => JSON.stringify(value ?? ''))
        .join(',')
    ),
  ];

  const csvAsString = reportArray.join('\r\n');

  const fromTime = includeIncomplete
    ? filters.createdFrom
    : filters.completedFrom;
  const toTime = includeIncomplete ? filters.createdTo : filters.completedTo;

  const dateString =
    fromTime && toTime
      ? `${fromTime.toLocaleDateString()}_${toTime.toLocaleDateString()}`
      : fromTime && !toTime
        ? `${fromTime.toLocaleDateString()}_now`
        : 'all_time';

  downloadCsv(csvAsString, `quickbit_pay_${dateString}.csv`);
};
